import Papa from 'papaparse'
import * as XLSX from 'xlsx'

const XLSX_EXTENSIONS = ['.xlsx', '.xls']
const CSV_EXTENSIONS = ['.csv']

const cellToString = (value: unknown): string => {
    if (value == null) return ''
    return String(value).trim()
}

const normalizeRows = (rows: unknown[][]): string[][] =>
    rows
        .map((row) => row.map(cellToString))
        .filter((row) => row.some((cell) => cell.length > 0))

const getFileExtension = (filename: string): string => {
    const dotIndex = filename.lastIndexOf('.')
    if (dotIndex === -1) return ''
    return filename.slice(dotIndex).toLowerCase()
}

export const isXlsxFile = (file: File): boolean =>
    XLSX_EXTENSIONS.includes(getFileExtension(file.name))

export const isCsvFile = (file: File): boolean =>
    CSV_EXTENSIONS.includes(getFileExtension(file.name))

const parseCsvFile = (file: File): Promise<string[][]> =>
    new Promise((resolve, reject) => {
        Papa.parse(file, {
            skipEmptyLines: true,
            complete: (results) => {
                if (results.errors.length > 0) {
                    reject(new Error(results.errors[0].message))
                    return
                }
                resolve(normalizeRows(results.data as unknown[][]))
            },
            error: (error) => reject(error),
        })
    })

const parseXlsxFile = async (file: File): Promise<string[][]> => {
    const buffer = await file.arrayBuffer()
    const workbook = XLSX.read(buffer, { type: 'array' })
    const firstSheetName = workbook.SheetNames[0]
    if (!firstSheetName) return []

    const sheet = workbook.Sheets[firstSheetName]
    const rows = XLSX.utils.sheet_to_json<unknown[]>(sheet, {
        header: 1,
        defval: '',
        raw: false,
    })

    return normalizeRows(rows)
}

export const parseSpreadsheetFile = async (file: File): Promise<string[][]> => {
    if (isXlsxFile(file)) {
        return parseXlsxFile(file)
    }
    if (isCsvFile(file)) {
        return parseCsvFile(file)
    }

    throw new Error('Unsupported file type. Please upload a CSV or XLSX file.')
}

export const downloadSampleCsv = (filename: string, content: string) => {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()
    URL.revokeObjectURL(url)
}

export const BULK_UPLOAD_SAMPLE_CSV = 'handle,tags\ncreator1,"arts,fashion"\ncreator2,tech'

export const BULK_UPLOAD_ACCEPTED_FILE_TYPES = '.csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
